import { render, staticRenderFns } from "./things_head.vue?vue&type=template&id=477acb5c&scoped=true&"
import script from "./things_head.vue?vue&type=script&lang=js&"
export * from "./things_head.vue?vue&type=script&lang=js&"
import style0 from "./things_head.vue?vue&type=style&index=0&id=477acb5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477acb5c",
  null
  
)

export default component.exports